module.exports = __webpack_public_path__ + "img/joinus-6.c56350ec.png";